import React, { Fragment } from 'react';
import Helmet from 'react-helmet';

import { search } from '~/state/ducks/users/operations';

import Search from '~/views/common/Search';
import Heading from '~/views/common/Heading';


const filters = ['archived', 'deleted'];


const Users = () => (
    <Fragment>
        <Helmet title="Users" />

        <Heading
            header="Users"
            subheader="Search"
            iconName="users"
        />

        <Search
            placeholder="Name / Email / ID"
            onSubmit={search}
            filters={filters}
        />
    </Fragment>
);

export default Users;
